const {
  API_URL,
  SOCKET_IO_PATH,
  SOCKET_IO_URL,
  HAWK_URL,
  USE_RELATIVE,
  DEFAULT_TIMEZONE,
} = process.env.TMS_CONFIG;

const baseUrl = window.location.origin;

let tmsLoginApiUrl = `${API_URL}/login`;
let tmsGraphqlApiUrl = API_URL;
let tmsUploadUrl = `${API_URL}/upload`;
let tmsCheckUsernameUrl = `${API_URL}/check_username`;
let tmsCheckNamespaceUrl = `${API_URL}/check_namespace`;
let tmsCheckExternalIdUrl = `${API_URL}/check_external_id`;
let tmsSocketIoUrl = SOCKET_IO_URL;
let tmsSendMattermostNotifUrl = `${API_URL}/send_mattermost_notif`;
let tmsTrackingGetOrderStatus = `${API_URL}/get_order_status`;
let tmsTrackingGetPositions = `${API_URL}/get_positions`;
let tmsTrackingGetRealtimePosition = `${API_URL}/get_realtime_position`;
let tmsGetPositionsByDeviceid = `${API_URL}/get_positions_by_deviceid`;
let tmsSentry = `${API_URL}/sentry`;

if (USE_RELATIVE) {
  tmsLoginApiUrl = `${baseUrl}${API_URL}/login`;
  tmsGraphqlApiUrl = `${baseUrl}${API_URL}`;
  tmsUploadUrl = `${baseUrl}${API_URL}/upload`;
  tmsCheckUsernameUrl = `${baseUrl}${API_URL}/check_username`;
  tmsCheckNamespaceUrl = `${baseUrl}${API_URL}/check_namespace`;
  tmsCheckExternalIdUrl = `${baseUrl}${API_URL}/check_external_id`;
  tmsSendMattermostNotifUrl = `${baseUrl}${API_URL}/send_mattermost_notif`;
  tmsSocketIoUrl = `${baseUrl}${SOCKET_IO_URL}`;
  tmsTrackingGetOrderStatus = `${baseUrl}${API_URL}/get_order_status`;
  tmsTrackingGetPositions = `${baseUrl}${API_URL}/get_positions`;
  tmsTrackingGetRealtimePosition = `${baseUrl}${API_URL}/get_realtime_position`;
  tmsGetPositionsByDeviceid = `${baseUrl}${API_URL}/get_positions_by_deviceid`;
  tmsSentry = `${baseUrl}${API_URL}/sentry`;
}

export default {
  tmsLoginApiUrl,
  tmsGraphqlApiUrl,
  tmsUploadUrl,
  tmsCheckUsernameUrl,
  tmsCheckNamespaceUrl,
  tmsCheckExternalIdUrl,
  tmsSocketIoUrl,
  tmsSendMattermostNotifUrl,
  tmsSocketIoPath: SOCKET_IO_PATH,
  hawkUrl: HAWK_URL,
  storageVersion: 1.0,
  defaultTimezone: DEFAULT_TIMEZONE,
  tmsTrackingGetOrderStatus,
  tmsTrackingGetPositions,
  tmsTrackingGetRealtimePosition,
  tmsGetPositionsByDeviceid,
  tmsSentry,
};



// WEBPACK FOOTER //
// ./src/config/index.js